/** Sections */
export const IDENTIFICATION = 'IDENTIFICATION';
export const IDENTIFICATION_INTRO = 'IDENTIFICATION_INTRO';
export const IDENTIFICATION_NAME = 'IDENTIFICATION_NAME';
export const IDENTIFICATION_BIRTH_DATE = 'IDENTIFICATION_BIRTH_DATE';
export const IDENTIFICATION_BIRTH_PLACE = 'IDENTIFICATION_BIRTH_PLACE';
export const IDENTIFICATION_SSN = 'IDENTIFICATION_SSN';
export const IDENTIFICATION_OTHER_NAMES = 'IDENTIFICATION_OTHER_NAMES';
export const IDENTIFICATION_CONTACTS = 'IDENTIFICATION_CONTACTS';
export const IDENTIFICATION_PHYSICAL = 'IDENTIFICATION_PHYSICAL';
export const IDENTIFICATION_REVIEW = 'IDENTIFICATION_REVIEW';

export const HISTORY = 'HISTORY';
export const HISTORY_INTRO = 'HISTORY_INTRO';
export const HISTORY_RESIDENCE = 'HISTORY_RESIDENCE';
export const HISTORY_EMPLOYMENT = 'HISTORY_EMPLOYMENT';
export const HISTORY_EDUCATION = 'HISTORY_EDUCATION';
export const HISTORY_FEDERAL = 'HISTORY_FEDERAL';
export const HISTORY_REVIEW = 'HISTORY_REVIEW';

export const RELATIONSHIPS = 'RELATIONSHIPS';
export const RELATIONSHIPS_INTRO = 'RELATIONSHIPS_INTRO';
export const RELATIONSHIPS_STATUS = 'RELATIONSHIPS_STATUS';
export const RELATIONSHIPS_STATUS_MARITAL = 'RELATIONSHIPS_STATUS_MARITAL';
export const RELATIONSHIPS_STATUS_COHABITANTS = 'RELATIONSHIPS_STATUS_COHABITANTS';
export const RELATIONSHIPS_PEOPLE = 'RELATIONSHIPS_PEOPLE';
export const RELATIONSHIPS_RELATIVES = 'RELATIONSHIPS_RELATIVES';
export const RELATIONSHIPS_REVIEW = 'RELATIONSHIPS_REVIEW';

export const CITIZENSHIP = 'CITIZENSHIP';
export const CITIZENSHIP_INTRO = 'CITIZENSHIP_INTRO';
export const CITIZENSHIP_US_PASSPORT = 'CITIZENSHIP_US_PASSPORT';
export const CITIZENSHIP_STATUS = 'CITIZENSHIP_STATUS';
export const CITIZENSHIP_MULTIPLE = 'CITIZENSHIP_MULTIPLE';
export const CITIZENSHIP_PASSPORTS = 'CITIZENSHIP_PASSPORTS';
export const CITIZENSHIP_REVIEW = 'CITIZENSHIP_REVIEW';

export const MILITARY = 'MILITARY';
export const MILITARY_INTRO = 'MILITARY_INTRO';
export const MILITARY_SELECTIVE = 'MILITARY_SELECTIVE';
export const MILITARY_HISTORY = 'MILITARY_HISTORY';
export const MILITARY_DISCIPLINARY = 'MILITARY_DISCIPLINARY';
export const MILITARY_FOREIGN = 'MILITARY_FOREIGN';
export const MILITARY_REVIEW = 'MILITARY_REVIEW';

export const FOREIGN = 'FOREIGN';
export const FOREIGN_INTRO = 'FOREIGN_INTRO';
export const FOREIGN_CONTACTS = 'FOREIGN_CONTACTS';
export const FOREIGN_ACTIVITIES = 'FOREIGN_ACTIVITIES';
export const FOREIGN_ACTIVITIES_INTRO = 'FOREIGN_ACTIVITIES_INTRO';
export const FOREIGN_ACTIVITIES_DIRECT = 'FOREIGN_ACTIVITIES_DIRECT';
export const FOREIGN_ACTIVITIES_INDIRECT = 'FOREIGN_ACTIVITIES_INDIRECT';
export const FOREIGN_ACTIVITIES_REAL_ESTATE = 'FOREIGN_ACTIVITIES_REAL_ESTATE';
export const FOREIGN_ACTIVITIES_BENEFITS = 'FOREIGN_ACTIVITIES_BENEFITS';
export const FOREIGN_ACTIVITIES_CURRENT = 'FOREIGN_ACTIVITIES_CURRENT';
export const FOREIGN_ACTIVITIES_FUTURE = 'FOREIGN_ACTIVITIES_FUTURE';
export const FOREIGN_ACTIVITIES_ONGOINGSUPPORT = 'FOREIGN_ACTIVITIES_ONGOINGSUPPORT';
export const FOREIGN_ACTIVITIES_SUPPORT = 'FOREIGN_ACTIVITIES_SUPPORT';
export const FOREIGN_BUSINESS = 'FOREIGN_BUSINESS';
export const FOREIGN_BUSINESS_INTRO = 'FOREIGN_BUSINESS_INTRO';
export const FOREIGN_BUSINESS_ADVICE = 'FOREIGN_BUSINESS_ADVICE';
export const FOREIGN_BUSINESS_FAMILY = 'FOREIGN_BUSINESS_FAMILY';
export const FOREIGN_BUSINESS_EMPLOYMENT = 'FOREIGN_BUSINESS_EMPLOYMENT';
export const FOREIGN_BUSINESS_VENTURES = 'FOREIGN_BUSINESS_VENTURES';
export const FOREIGN_BUSINESS_CONFERENCES = 'FOREIGN_BUSINESS_CONFERENCES';
export const FOREIGN_BUSINESS_CONTACT = 'FOREIGN_BUSINESS_CONTACT';
export const FOREIGN_BUSINESS_SPONSORSHIP = 'FOREIGN_BUSINESS_SPONSORSHIP';
export const FOREIGN_BUSINESS_POLITICAL = 'FOREIGN_BUSINESS_POLITICAL';
export const FOREIGN_BUSINESS_VOTING = 'FOREIGN_BUSINESS_VOTING';
export const FOREIGN_TRAVEL = 'FOREIGN_TRAVEL';
export const FOREIGN_REVIEW = 'FOREIGN_REVIEW';

export const FINANCIAL = 'FINANCIAL';
export const FINANCIAL_INTRO = 'FINANCIAL_INTRO';
export const FINANCIAL_BANKRUPTCY = 'FINANCIAL_BANKRUPTCY';
export const FINANCIAL_ALIMONY = 'FINANCIAL_ALIMONY';
export const FINANCIAL_CHILD_SUPPORT = 'FINANCIAL_CHILD_SUPPORT';
export const FINANCIAL_CIVIL_JUDGEMENT = 'FINANCIAL_CIVIL_JUDGEMENT';
export const FINANCIAL_LIEN = 'FINANCIAL_LIEN';
export const FINANCIAL_FORECLOSURE = 'FINANCIAL_FORECLOSURE';
export const FINANCIAL_REPOSSESSION = 'FINANCIAL_REPOSSESSION';
export const FINANCIAL_EVICTION = 'FINANCIAL_EVICTION';
export const FINANCIAL_ASSET_SEIZED = 'FINANCIAL_ASSET_SEIZED';
export const FINANCIAL_NONPAYMENT_NONFEDERAL = 'FINANCIAL_NONPAYMENT_NONFEDERAL';
export const FINANCIAL_GAMBLING = 'FINANCIAL_GAMBLING';
export const FINANCIAL_TAXES = 'FINANCIAL_TAXES';
export const FINANCIAL_FEDERAL_DEBT = 'FINANCIAL_FEDERAL_DEBT';
export const FINANCIAL_CARD = 'FINANCIAL_CARD';
export const FINANCIAL_CREDIT = 'FINANCIAL_CREDIT';
export const FINANCIAL_DELINQUENT = 'FINANCIAL_DELINQUENT';
export const FINANCIAL_NONPAYMENT = 'FINANCIAL_NONPAYMENT';
export const FINANCIAL_REVIEW = 'FINANCIAL_REVIEW';

export const SUBSTANCE_USE = 'SUBSTANCE_USE';
export const SUBSTANCE_USE_INTRO = 'SUBSTANCE_USE_INTRO';
export const SUBSTANCE_USE_DRUGS = 'SUBSTANCE_USE_DRUGS';
export const SUBSTANCE_USE_DRUGS_INTRO = 'SUBSTANCE_USE_DRUGS_INTRO';
export const SUBSTANCE_USE_DRUGS_USAGE = 'SUBSTANCE_USE_DRUGS_USAGE';
export const SUBSTANCE_USE_DRUGS_PURCHASE = 'SUBSTANCE_USE_DRUGS_PURCHASE';
export const SUBSTANCE_USE_DRUGS_CLEARANCE = 'SUBSTANCE_USE_DRUGS_CLEARANCE';
export const SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY = 'SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY';
export const SUBSTANCE_USE_DRUGS_MISUSE = 'SUBSTANCE_USE_DRUGS_MISUSE';
export const SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT = 'SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT';
export const SUBSTANCE_USE_DRUGS_ORDERED = 'SUBSTANCE_USE_DRUGS_ORDERED';
export const SUBSTANCE_USE_DRUGS_VOLUNTARY = 'SUBSTANCE_USE_DRUGS_VOLUNTARY';
export const SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE = 'SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE';
export const SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE = 'SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE';
export const SUBSTANCE_USE_ALCOHOL = 'SUBSTANCE_USE_ALCOHOL';
export const SUBSTANCE_USE_ALCOHOL_INTRO = 'SUBSTANCE_USE_INTRO';
export const SUBSTANCE_USE_ALCOHOL_NEGATIVE = 'SUBSTANCE_USE_ALCOHOL_NEGATIVE';
export const SUBSTANCE_USE_ALCOHOL_ORDERED = 'SUBSTANCE_USE_ALCOHOL_ORDERED';
export const SUBSTANCE_USE_ALCOHOL_VOLUNTARY = 'SUBSTANCE_USE_ALCOHOL_VOLUNTARY';
export const SUBSTANCE_USE_ALCOHOL_ADDITIONAL = 'SUBSTANCE_USE_ALCOHOL_ADDITIONAL';
export const SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL = 'SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL';
export const SUBSTANCE_USE_THC = 'SUBSTANCE_USE_THC';
export const SUBSTANCE_USE_THC_INTRO = 'SUBSTANCE_USE_THC_INTRO';
export const SUBSTANCE_USE_THC_USAGE = 'SUBSTANCE_USE_THC_USAGE';
export const SUBSTANCE_USE_THC_PURCHASE = 'SUBSTANCE_USE_THC_PURCHASE';
export const SUBSTANCE_USE_THC_CLEARANCE = 'SUBSTANCE_USE_THC_CLEARANCE';
export const SUBSTANCE_USE_THC_PUBLIC_SAFETY = 'SUBSTANCE_USE_THC_PUBLIC_SAFETY';
export const SUBSTANCE_USE_REVIEW = 'SUBSTANCE_USE_REVIEW';

export const LEGAL = 'LEGAL';
export const LEGAL_INTRO = 'LEGAL_INTRO';
export const LEGAL_POLICE = 'LEGAL_POLICE';
export const LEGAL_POLICE_INTRO = 'LEGAL_POLICE_INTRO';
export const LEGAL_POLICE_OFFENSES = 'LEGAL_POLICE_OFFENSES';
export const LEGAL_POLICE_ADDITIONAL_OFFENSES = 'LEGAL_POLICE_ADDITIONAL_OFFENSES';
export const LEGAL_POLICE_DOMESTIC_VIOLENCE = 'LEGAL_POLICE_DOMESTIC_VIOLENCE';
export const LEGAL_CRIMINAL_CONVICTIONS = 'LEGAL_CRIMINAL_CONVICTIONS'; //
export const LEGAL_INVESTIGATIONS = 'LEGAL_INVESTIGATIONS';
export const LEGAL_INVESTIGATIONS_INTRO = 'LEGAL_INVESTIGATIONS_INTRO';
export const LEGAL_INVESTIGATIONS_HISTORY = 'LEGAL_INVESTIGATIONS_HISTORY';
export const LEGAL_INVESTIGATIONS_REVOKED = 'LEGAL_INVESTIGATIONS_REVOKED';
export const LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES = 'LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES';
export const LEGAL_INVESTIGATIONS_DEBARRED = 'LEGAL_INVESTIGATIONS_DEBARRED';
export const LEGAL_INVESTIGATIONS_FOREIGN = 'LEGAL_INVESTIGATIONS_FOREIGN';
export const LEGAL_INVESTIGATIONS_PIV_ISSUES = 'LEGAL_INVESTIGATIONS_PIV_ISSUES';
export const LEGAL_COURT = 'LEGAL_COURT';
export const LEGAL_HANDLING_PROTECTED_INFO = 'LEGAL_HANDLING_PROTECTED_INFO';
export const LEGAL_HANDLING_PROTECTED_INFO_INTRO = 'LEGAL_HANDLING_PROTECTED_INFO_INTRO';
export const LEGAL_TECHNOLOGY = 'LEGAL_TECHNOLOGY';
export const LEGAL_TECHNOLOGY_NONCOMPLIANCE = 'LEGAL_TECHNOLOGY_NONCOMPLIANCE';
export const LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED = 'LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED';
export const LEGAL_TECHNOLOGY_INTRO = 'LEGAL_TECHNOLOGY_INTRO';
export const LEGAL_TECHNOLOGY_UNAUTHORIZED = 'LEGAL_TECHNOLOGY_UNAUTHORIZED';
export const LEGAL_TECHNOLOGY_MANIPULATING = 'LEGAL_TECHNOLOGY_MANIPULATING';
export const LEGAL_TECHNOLOGY_DENIED = 'LEGAL_TECHNOLOGY_DENIED';
export const LEGAL_TECHNOLOGY_UNLAWFUL = 'LEGAL_TECHNOLOGY_UNLAWFUL';
export const LEGAL_ASSOCIATIONS = 'LEGAL_ASSOCIATIONS';
export const LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION = 'LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION';
export const LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP = 'LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP'; // PVQ
export const LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT = 'LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT'; // PVQ
export const LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY = 'LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY'; // PVQ
export const LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP = 'LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP'; // PVQ
export const LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP = 'LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP'; // PVQ
export const LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION = 'LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION'; // PVQ
export const LEGAL_ASSOCIATIONS_VIOLENT_ACTS = 'LEGAL_ASSOCIATIONS_VIOLENT_ACTS'; // PVQ
export const LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY = 'LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY'; // PVQ
export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM = 'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM'; // PVQ
export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT = 'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT'; // PVQ
export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION = 'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION'; // PVQ
export const LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY = 'LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY'; // PVQ
export const LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM = 'LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM';
export const LEGAL_ASSOCIATIONS_ADVOCATING = 'LEGAL_ASSOCIATIONS_ADVOCATING';
export const LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW = 'LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW';
export const LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE = 'LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE';
export const LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW = 'LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW';
export const LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION = 'LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION';
export const LEGAL_REVIEW = 'LEGAL_REVIEW';

export const PSYCHOLOGICAL = 'PSYCHOLOGICAL';
export const PSYCHOLOGICAL_INTRO = 'PSYCHOLOGICAL_INTRO';
export const PSYCHOLOGICAL_COMPETENCE = 'PSYCHOLOGICAL_COMPETENCE';
export const PSYCHOLOGICAL_CONSULTATIONS = 'PSYCHOLOGICAL_CONSULTATIONS';
export const PSYCHOLOGICAL_HOSPITALIZATIONS = 'PSYCHOLOGICAL_HOSPITALIZATIONS';
export const PSYCHOLOGICAL_DIAGNOSES = 'PSYCHOLOGICAL_DIAGNOSES';
export const PSYCHOLOGICAL_CONDITIONS = 'PSYCHOLOGICAL_CONDITIONS';
export const PSYCHOLOGICAL_REVIEW = 'PSYCHOLOGICAL_REVIEW';

export const REVIEW_AND_SUBMIT = 'REVIEW_AND_SUBMIT';
export const REVIEW_AND_SUBMIT_COMMENTS = 'PACKAGE_COMMENTS';
export const REVIEW_AND_SUBMIT_REVIEW = 'REVIEW_AND_SUBMIT_REVIEW';
export const REVIEW_AND_SUBMIT_SUBMIT = 'REVIEW_AND_SUBMIT_SUBMIT';
export const REVIEW_AND_SUBMIT_PRINT = 'REVIEW_AND_SUBMIT_PRINT';

/** This contains keys that are valid subsections with data */
export const SUBSECTION_KEYS = [
  IDENTIFICATION_NAME,
  IDENTIFICATION_BIRTH_DATE,
  IDENTIFICATION_BIRTH_PLACE,
  IDENTIFICATION_SSN,
  IDENTIFICATION_OTHER_NAMES,
  IDENTIFICATION_CONTACTS,
  IDENTIFICATION_PHYSICAL,

  HISTORY_RESIDENCE,
  HISTORY_EMPLOYMENT,
  HISTORY_EDUCATION,
  HISTORY_FEDERAL,

  RELATIONSHIPS_STATUS_MARITAL,
  RELATIONSHIPS_STATUS_COHABITANTS,
  RELATIONSHIPS_PEOPLE,
  RELATIONSHIPS_RELATIVES,

  CITIZENSHIP_US_PASSPORT,
  CITIZENSHIP_STATUS,
  CITIZENSHIP_MULTIPLE,
  CITIZENSHIP_PASSPORTS,

  MILITARY_SELECTIVE,
  MILITARY_HISTORY,
  MILITARY_DISCIPLINARY,
  MILITARY_FOREIGN,

  FOREIGN_CONTACTS,
  FOREIGN_ACTIVITIES_INTRO,
  FOREIGN_ACTIVITIES_DIRECT,
  FOREIGN_ACTIVITIES_INDIRECT,
  FOREIGN_ACTIVITIES_REAL_ESTATE,
  FOREIGN_ACTIVITIES_BENEFITS,
  FOREIGN_ACTIVITIES_CURRENT,
  FOREIGN_ACTIVITIES_FUTURE,
  FOREIGN_ACTIVITIES_ONGOINGSUPPORT,
  FOREIGN_ACTIVITIES_SUPPORT,
  FOREIGN_BUSINESS_ADVICE,
  FOREIGN_BUSINESS_FAMILY,
  FOREIGN_BUSINESS_EMPLOYMENT,
  FOREIGN_BUSINESS_VENTURES,
  FOREIGN_BUSINESS_CONFERENCES,
  FOREIGN_BUSINESS_CONTACT,
  FOREIGN_BUSINESS_SPONSORSHIP,
  FOREIGN_BUSINESS_POLITICAL,
  FOREIGN_BUSINESS_VOTING,
  FOREIGN_TRAVEL,

  FINANCIAL_BANKRUPTCY,
  FINANCIAL_GAMBLING,
  FINANCIAL_FEDERAL_DEBT,
  FINANCIAL_ALIMONY,
  FINANCIAL_CHILD_SUPPORT,
  FINANCIAL_CIVIL_JUDGEMENT,
  FINANCIAL_LIEN,
  FINANCIAL_FORECLOSURE,
  FINANCIAL_REPOSSESSION,
  FINANCIAL_EVICTION,
  FINANCIAL_ASSET_SEIZED,
  FINANCIAL_NONPAYMENT_NONFEDERAL,
  FINANCIAL_TAXES,
  FINANCIAL_CARD,
  FINANCIAL_CREDIT,
  FINANCIAL_DELINQUENT,
  FINANCIAL_NONPAYMENT,

  SUBSTANCE_USE_DRUGS_USAGE,
  SUBSTANCE_USE_DRUGS_PURCHASE,
  SUBSTANCE_USE_DRUGS_CLEARANCE,
  SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY,
  SUBSTANCE_USE_DRUGS_MISUSE,
  SUBSTANCE_USE_DRUGS_ORDERED,
  SUBSTANCE_USE_DRUGS_VOLUNTARY,
  SUBSTANCE_USE_ALCOHOL_NEGATIVE,
  SUBSTANCE_USE_ALCOHOL_ORDERED,
  SUBSTANCE_USE_ALCOHOL_VOLUNTARY,
  SUBSTANCE_USE_ALCOHOL_ADDITIONAL,
  SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL,
  SUBSTANCE_USE_THC_USAGE,
  SUBSTANCE_USE_THC_PURCHASE,
  SUBSTANCE_USE_THC_CLEARANCE,
  SUBSTANCE_USE_THC_PUBLIC_SAFETY,

  LEGAL_POLICE_OFFENSES,
  LEGAL_POLICE_ADDITIONAL_OFFENSES,
  LEGAL_POLICE_DOMESTIC_VIOLENCE,
  LEGAL_CRIMINAL_CONVICTIONS, //
  LEGAL_INVESTIGATIONS_HISTORY,
  LEGAL_INVESTIGATIONS_REVOKED,
  LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES,
  LEGAL_INVESTIGATIONS_PIV_ISSUES,
  LEGAL_INVESTIGATIONS_DEBARRED,
  LEGAL_INVESTIGATIONS_FOREIGN,
  LEGAL_COURT,
  LEGAL_TECHNOLOGY_UNAUTHORIZED,
  LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED,
  LEGAL_TECHNOLOGY_NONCOMPLIANCE,

  LEGAL_TECHNOLOGY_MANIPULATING,
  LEGAL_TECHNOLOGY_DENIED,
  LEGAL_TECHNOLOGY_UNLAWFUL,
  LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION,
  LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP, // PVQ
  LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT, // PVQ
  LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION, // PVQ
  LEGAL_ASSOCIATIONS_VIOLENT_ACTS, // PVQ
  LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION, // PVQ
  LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY, // PVQ
  LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM,
  LEGAL_ASSOCIATIONS_ADVOCATING,
  LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW,
  LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE,
  LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW,
  LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION,

  PSYCHOLOGICAL_COMPETENCE,
  PSYCHOLOGICAL_CONSULTATIONS,
  PSYCHOLOGICAL_HOSPITALIZATIONS,
  PSYCHOLOGICAL_DIAGNOSES,
  PSYCHOLOGICAL_CONDITIONS,

  REVIEW_AND_SUBMIT_COMMENTS,
];
